import styled, { css } from 'styled-components';

export const TableStc = styled.table`
    width: 100%;
    border-collapse: collapse;

    th {
        text-align: left;
    }
    th,
    td {
        height: 40px;
        border-top: 1px solid ${({ theme }) => theme.borderPaleGrey};
    }

    thead th {
        ${getColor}
    }

    tbody tr:last-child td {
        border-bottom: 1px solid ${({ theme }) => theme.borderPaleGrey};
    }
`;

function getColor({ theme, Type }) {
    switch (Type) {
        case 'primary':
        default: {
            return css`
                color: ${theme.primary.fg};
            `;
        }
    }
}
